module.exports = __webpack_public_path__ + "img/button_presnaZhoda_off.3da1e53f.svg";